/// <reference path="managers/authentication.ts" />

namespace SPA
{
	export class WollmilchApplication
	{
		private ToastManager: ToastManager;
		private Authentication: AuthenticationManager;
		private ContactManager: ContactManager;
		private ObjectManager: ObjectManager;
		private GlobalTabControl: ui.tab.TabControl;
		private UserAgent: string;
		private RemotePath: string;
		private Messages: {[key: string]: string};
		private Config: {[key: string]: string|number|object};
		private supportedLanguage: string[];
		private body: JQuery;

		constructor(data: { url: string, RemotePath: string })
		{
			// We need the backend url at the very beginning
			// Todo: looks weired in that place
			Wollmilch.URL = data.url;
			Wollmilch.useHTTPS = location.protocol === 'https:';

			this.ToastManager 			= new ToastManager( 60 );
			this.Authentication			= new AuthenticationManager();
			this.ContactManager                = new ContactManager();
			this.ObjectManager                 = new ObjectManager();
			this.GlobalTabControl		= new ui.tab.TabControl( 'tabs' );
			this.UserAgent					= navigator.userAgent;
			this.RemotePath = data.RemotePath;
			this.supportedLanguage	= [ 'de-DE' ];
			this.body								= ui.$$.div();
			this.Messages						= {};
			this.Config						= {};

			let lang = navigator.language;

			if ( $.inArray( lang, this.supportedLanguage ) === -1 )
			{
				lang = this.getDefaultLanguage();
			}

			$.getJSON("loc/" + lang + ".json", '', ( data: {[key: string]: any} ) => this.Messages = data );

			$.getJSON("conf/app.json", '', (data: {[key: string]: any} ) => {
				this.Config = data;
				$(".app-version").text( String(this.getConfigValue("Version")) );
			});

			this.body.addClass( 'main-content-screen' );

			this.GlobalTabControl.BarInABox( true );

			this.GlobalTabControl.Build();
			// Todo Hide the annoying line this way for now
			this.GlobalTabControl.Root().addClass('hidden');

			this.body.append( this.GlobalTabControl.Root() );

			// $( document.body ).append( this.body );
			$( "#main-content" ).append( this.body );

			this.Authentication.validateAuthtoken();
		}

		public getAuthenticationManager() : AuthenticationManager
		{
			return this.Authentication;
		}

		public getDocumentBody(): JQuery
		{
			return this.body;
		}

		public getContactManager(): ContactManager
		{
			return this.ContactManager;
		}

		public getObjectManager(): ObjectManager
		{
			return this.ObjectManager;
		}

		public getRemotePath(): string
		{
			return this.RemotePath;
		}

		public setObjectManager(OManager: ObjectManager): void
		{
			this.ObjectManager = OManager;
		}

		public getGlobalTabControl(): ui.tab.TabControl
		{
			return this.GlobalTabControl;
		}

		public getMessage( key: string ): string;
		public getMessage( key: string, tree: {[key: string]: any} ): string;

		public getMessage( key: string, tree?: {[key: string]: any} ): string
		{
			if ( !tree )
			{
				tree = this.Messages;
			}

			const keys : string[] = key.split( '.' );

			if ( !( tree[ keys[ 0 ] ] ) )
			{
				return '';
			}

			if ( keys.length === 1 )
			{
				return tree[ keys[ 0 ] ];
			}

			return this.getMessage( keys.splice( 1 ).join( '.' ), tree[ keys[ 0 ] ] );
		}

		public getSpanMessage( key: string ) : JQuery<HTMLSpanElement>
		{
			const span = ui.$$.span();
			const mes = this.getMessage( key );

			if ( typeof mes === 'string' )
			{
				span.text( mes );
			}

			return span;
		}

		public addToast( toast: ToastDescriptor ) : void
		{
			this.ToastManager.addToast( toast );
		}

		public addNotify( notify: NotifyDescriptor ) : void
		{
			this.ToastManager.addNotify( notify );
		}

		public remToast(toast: Toast): void
		{
			this.ToastManager.remToast( toast );
		}

		private getDefaultLanguage() : string
		{
			return 'de-DE';
		}

		public getConfigValue( key: string ): string|number|object{
			try {
				return this.Config[key];
			}
			catch (e) {
				console.log("ERROR in app.getConfigValue");
				return "";
			}
		}

		public static Initialize()
		{
			if ( app instanceof WollmilchApplication )
			{
				return;
			}

			// Init accounting settings
			accounting.settings = {
				currency: {
					symbol: '€',
					decimal: ',',
					thousand: ".",
					format: {
						pos: '%v',
						neg: '%v',
						zero: ''
					},
					precision: 2
				},
				number: {
					precision: 0,
					decimal: ",",
					thousand: ".",
				}
			};

			// Some helper for currency input focus
			$('body').on('focus', '.currency', (e) =>
			{
				const input = (e.currentTarget as HTMLInputElement);
				if (input.value.trim())
				{
					input.value = accounting.unformat(input.value, ',').toString().replace('.', ',');
				}
			}).on('blur', '.currency', (e) =>
			{
				const input = (e.currentTarget as HTMLInputElement);
				if (input.value)
				{
					const floatvalue = accounting.unformat(input.value, ',');
					$(input).data('value', floatvalue);

					// Double conversion preserves decimals
					input.value = floatvalue.toString();
					input.value = accounting.formatMoney(floatvalue);
				}
			}).on('focus', '.number', (e) => {
				const input = (e.currentTarget as HTMLInputElement);
				if (input.value.trim())
				{
					input.value = accounting.unformat(input.value, ',').toString();
				}
			}).on('blur', '.number', (e) => {
				const input = (e.currentTarget as HTMLInputElement);
				if (input.value) {
					input.value = accounting.formatNumber(parseInt(input.value, 10));
				}
			}).on('account', '.btn-ajax', (e) => {
				const button = $(e.currentTarget);
				const buttonText = button.data('progress') || 'Anfrage läuft ...';

				button.data('html', button.html());
				button.html('<i class="fas fa-spinner fa-spin"></i> <span>' + buttonText + '</span>');
			});
			// @todo move mouseout event somewhere else
			let leaveTimer: number = 0;
			$('.side-menu').on('mouseleave', (e) => {
				leaveTimer = setTimeout(() => {
					$(e.currentTarget).find('.dropdown.open').removeClass('open');
				}, 750);
			}).on('mouseenter', (e) => {
				clearTimeout(leaveTimer);
			});

			$.getJSON(
				'conf/ajax.json?_=' + new Date().getTime(),
				( data ) => {
					app = new WollmilchApplication(data);
				}
			);

			// ? Sollte ein Fenster zum nicht schließen anzeigen, funktioniert nicht immer!!!!
			// window.onbeforeunload = () => false;
		}
	}
}

/* Deepmerge - Start */
function isMergeableObject(val: any) {
	const nonNullObject = val && typeof val === 'object';

	return nonNullObject
		&& Object.prototype.toString.call(val) !== '[object RegExp]'
		&& Object.prototype.toString.call(val) !== '[object Date]';
}

function emptyTarget(val: any) {
	return Array.isArray(val) ? [] : {};
}

function cloneIfNecessary(value: any, optionsArgument: any) {
	const clone = optionsArgument && optionsArgument.clone === true;
	return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value;
}

function defaultArrayMerge(target: any, source: any, optionsArgument: any) {
	const destination = target.slice();
	source.forEach((e: any, i: any) => {
		if (typeof destination[i] === 'undefined') {
			destination[i] = cloneIfNecessary(e, optionsArgument);
		} else if (isMergeableObject(e)) {
			destination[i] = deepmerge(target[i], e, optionsArgument);
		} else if (target.indexOf(e) === -1) {
			destination.push(cloneIfNecessary(e, optionsArgument));
		}
	});
	return destination;
}

function mergeObject(target: any, source: any, optionsArgument: any) {
	const destination: any = {};
	if (isMergeableObject(target)) {
		Object.keys(target).forEach((key: any) => {
			destination[key] = cloneIfNecessary(target[key], optionsArgument);
		});
	}
	Object.keys(source).forEach((key: any) => {
		if (!isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneIfNecessary(source[key], optionsArgument);
		} else {
			destination[key] = deepmerge(target[key], source[key], optionsArgument);
		}
	});
	return destination;
}

function deepmerge(target: any, source: any, optionsArgument: any): any {
	const array = Array.isArray(source);
	const options = optionsArgument || {arrayMerge: defaultArrayMerge};
	const arrayMerge = options.arrayMerge || defaultArrayMerge;

	if (array) {
		return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument);
	} else {
		return mergeObject(target, source, optionsArgument);
	}
}

deepmerge.all = function deepmergeAll(array: any, optionsArgument: any) {
	if (!Array.isArray(array) || array.length < 2) {
		throw new Error('first argument should be an array with at least two elements');
	}

	// we are sure there are at least 2 values, so it is safe to have no initial value
	return array.reduce((prev, next) => {
		return deepmerge(prev, next, optionsArgument);
	});
};
/* Deepmerge - Ends */

let app: SPA.WollmilchApplication;

$( document ).ready( () => SPA.WollmilchApplication.Initialize() );

